import { FETCH_MESSAGES, FETCH_TETRISGAMESCORES, FETCH_WHACKAMOLEGAMESCORES, FETCH_SNAKEGAMESCORES, FETCH_2048GAMESCORES } from '../actions/types';

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_MESSAGES:
      return action.payload;
    case FETCH_TETRISGAMESCORES:
      return action.payload;
    case FETCH_WHACKAMOLEGAMESCORES:
      return action.payload;
    case FETCH_SNAKEGAMESCORES:
      return action.payload;
    case FETCH_2048GAMESCORES:
      return action.payload;
    default:
      return state;
  }
};